<template>
  <modal id="editDiscount"
         :show="showModal"
         modal-classes="modal-dialog-centered modal-lg"
         showClose
         @close="resetForm()"
  >
    <template slot="header">
      <h4 class="modal-title">
        {{ $t('discounts.edit.titleText') }}
      </h4>
    </template>
    <template>
      <div class="text-center text-muted mb-2">
        <small>{{ $t('discounts.edit.helpText') }}</small>
      </div>

      <base-alert v-if="alert" dismissible :dismiss-callback="() => alert=false" type="danger">
        <!-- TODO: add error translation -->
        {{ getActionErrorDetails }}
      </base-alert>

      <form role="form" @submit.prevent="validate()">
        <div class="row">
          <label class="col-sm-3 col-form-label">{{ $t('generic.id') }}</label>
          <div class="col-md-9">
            <base-input
              disabled
              :value="formDetails.id">
            </base-input>
          </div>
        </div>

        <div class="row">
          <label class="col-sm-3 col-form-label">{{ $t('discounts.details.description') }}</label>
          <div class="col-md-9">
            <base-input :error="getError('description')">
                <textarea class="form-control"
                          name="description"
                          data-vv-as="'description'"
                          v-validate="modelValidations.required"
                          v-model="formDetails.description"
                          rows="2"/>
            </base-input>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-3 col-form-label">{{ $t('discounts.details.type') }}</label>
          <div class="col form-group">
            <el-select
              class="select-primary"
              name="role"
              v-model="formDetails.type"
            >
              <el-option
                v-for="option in availableTypes"
                class="select-primary"
                :value="option"
                :label="option"
                :key="option"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="row">
          <label class="col-sm-3 col-form-label">{{ $t('discounts.details.sort_priority') }}</label>
          <div class="col-md-9">
            <base-input :error="getError('sort_priority')">
              <base-input
                data-vv-as="'sort_priority'"
                name="sort_priority"
                v-validate="modelValidations.required"
                :error="getError('sort_priority')"
                v-model.number="formDetails.sort_priority"
                type="number">
              </base-input>
            </base-input>
          </div>
        </div>
        <div class="text-center">
          <base-button
            type="info"
            :loading="updating"
            class="my-4"
            native-type="submit"
          >{{ $t('discounts.edit.actionBtnLabel') }}
          </base-button>
        </div>
      </form>
    </template>
  </modal>
</template>


<script>
import {BaseAlert, Modal} from 'src/components';
import {Option, Select} from 'element-ui';
import {mapActions, mapState} from "vuex";
import discount_types from './discount_types';

export default {
  name: 'edit-discount-dialog',
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
    Modal,
    BaseAlert
  },
  props: {
    formDetails: {
      type: Object,
      required: true
    },
    show: {
      type: Boolean,
      required: true
    },
  },
  data() {
    return {
      alert: false,
      modelValidations: {
        required: {
          required: true
        }
      },
      availableTypes: discount_types
    }
  },
  computed: {
    ...mapState({
      updating: state => state.discount.updating,
      error: state => state.discount.error,
    }),
    getActionErrorDetails() {
      return this.error ? this.error.bodyText : null;
    },
    showModal() {
      return this.show == true
    }
  },
  methods: {
    ...mapActions(['UpdateDiscount']),
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    validate() {
      this.$validator.validateAll().then(isValid => {
        if (isValid) {
          this.update()
        }
      });
    },
    update: function () {
      this.UpdateDiscount(this.formDetails).then(() => {
        if (this.error != null) {
          this.alert = true
        } else {
          this.$notify({
            type: 'success',
            message: this.$t('discounts.edit.updatedNotification', this.formDetails),
            icon: 'tim-icons icon-alert-circle-exc'
          })
          this.resetForm()
        }
      });
    },
    resetForm: function () {
      this.$emit('close');
      // resetting alerts
      this.alert = false;

      // reset validation errors
      this.$validator.reset()
    }
  }
}
</script>
